import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-listNull",
  "use": "icon-listNull-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-listNull\">\r\n<path d=\"M20 50H10V30H20V50ZM12.5 47.5H17.5V32.5H12.5V47.5ZM33.75 50H23.75V20H33.75V50ZM26.25 47.5H31.25V22.5H26.25V47.5ZM53.3839 42.8661L46.25 35.7323L39.1161 42.8661L40.8839 44.6339L45 40.5178V55H47.5V40.5178L51.6161 44.6339L53.3839 42.8661ZM40 12.5H45V33.2323L46.25 31.9823L47.5 33.2323V10H37.5V40.7322L40 38.2322V12.5Z\" fill=\"#8A9097\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol